'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var USER_SHOW_GAMES_QUERY = 'USER_SHOW_GAMES_QUERY';
var USER_FETCH_PREFERENCES_COMMAND = 'USER_FETCH_PREFERENCES_COMMAND';
var USER_SHOW_SPORTSBOOK_QUERY = 'USER_SHOW_SPORTSBOOK_QUERY';
var USER_TIMESTAMP_PREFERENCES_QUERY = 'USER_TIMESTAMP_PREFERENCES_QUERY';
var USER_UPDATE_PREFERENCES_COMMAND = 'USER_UPDATE_PREFERENCES_COMMAND';
var USER_UPDATE_PREFERENCES_UPDATED = 'USER_UPDATE_PREFERENCES_UPDATED';
var USER_RESET_PREFERENCES_COMMAND = 'USER_RESET_PREFERENCES_COMMAND';
var USER_PREFERENCES_LOADING_UPDATED = 'USER_PREFERENCES_LOADING_UPDATED';
var USER_UPDATE_PREFERENCES_UPDATE_FAILED = 'USER_UPDATE_PREFERENCES_UPDATE_FAILED';
var USER_LOGGED_IN_QUERY = 'user-logged-in:query';
var USER_LOGGED_IN_UPDATED = 'user-logged-in:updated';
var USER_FIRST_LOGGED_IN_QUERY = 'user-first-log-in:query';
var USER_SET_FIRST_LOG_IN = 'user-set-first-log-in:command';
var USER_FIRST_LOG_IN_UPDATED = 'user-first-log-in:event';
var USER_REQUIRES_TERMS_ACCEPTANCE_QUERY = 'user-requires-terms-acceptance:query';
var USER_SET_REQUIRES_TERMS_ACCEPTANCE = 'user-set-requires-terms-acceptance:command';
var USER_REQUIRES_SOW_QUERY = 'user-requires-source-of-wealth:query';
var USER_SET_REQUIRES_SOW = 'user-set-source-of-wealth:command';
var USER_QUERY = 'user:query';
var USER_UPDATED = 'user:updated';
var USER_PROFILE_DATA = 'user:profile-data';
var USER_HANDLE_LOGIN = 'user-handle-login:event';
var TRACKING_LOGOUT = 'tracking-logout:event';
var USER_LOGOUT_KEYCLOAK = 'user-logout-keycloak:command';
var USER_LOGIN_KEYCLOAK = 'user-login-keycloak:command';
var USER_RESET_PASSWORD_KEYCLOAK_QUERY = 'user-reset-password-keycloak:query';
var UPDATE_USER_STATUS = 'update-user-status:command';

exports.TRACKING_LOGOUT = TRACKING_LOGOUT;
exports.UPDATE_USER_STATUS = UPDATE_USER_STATUS;
exports.USER_FETCH_PREFERENCES_COMMAND = USER_FETCH_PREFERENCES_COMMAND;
exports.USER_FIRST_LOGGED_IN_QUERY = USER_FIRST_LOGGED_IN_QUERY;
exports.USER_FIRST_LOG_IN_UPDATED = USER_FIRST_LOG_IN_UPDATED;
exports.USER_HANDLE_LOGIN = USER_HANDLE_LOGIN;
exports.USER_LOGGED_IN_QUERY = USER_LOGGED_IN_QUERY;
exports.USER_LOGGED_IN_UPDATED = USER_LOGGED_IN_UPDATED;
exports.USER_LOGIN_KEYCLOAK = USER_LOGIN_KEYCLOAK;
exports.USER_LOGOUT_KEYCLOAK = USER_LOGOUT_KEYCLOAK;
exports.USER_PREFERENCES_LOADING_UPDATED = USER_PREFERENCES_LOADING_UPDATED;
exports.USER_PROFILE_DATA = USER_PROFILE_DATA;
exports.USER_QUERY = USER_QUERY;
exports.USER_REQUIRES_SOW_QUERY = USER_REQUIRES_SOW_QUERY;
exports.USER_REQUIRES_TERMS_ACCEPTANCE_QUERY = USER_REQUIRES_TERMS_ACCEPTANCE_QUERY;
exports.USER_RESET_PASSWORD_KEYCLOAK_QUERY = USER_RESET_PASSWORD_KEYCLOAK_QUERY;
exports.USER_RESET_PREFERENCES_COMMAND = USER_RESET_PREFERENCES_COMMAND;
exports.USER_SET_FIRST_LOG_IN = USER_SET_FIRST_LOG_IN;
exports.USER_SET_REQUIRES_SOW = USER_SET_REQUIRES_SOW;
exports.USER_SET_REQUIRES_TERMS_ACCEPTANCE = USER_SET_REQUIRES_TERMS_ACCEPTANCE;
exports.USER_SHOW_GAMES_QUERY = USER_SHOW_GAMES_QUERY;
exports.USER_SHOW_SPORTSBOOK_QUERY = USER_SHOW_SPORTSBOOK_QUERY;
exports.USER_TIMESTAMP_PREFERENCES_QUERY = USER_TIMESTAMP_PREFERENCES_QUERY;
exports.USER_UPDATED = USER_UPDATED;
exports.USER_UPDATE_PREFERENCES_COMMAND = USER_UPDATE_PREFERENCES_COMMAND;
exports.USER_UPDATE_PREFERENCES_UPDATED = USER_UPDATE_PREFERENCES_UPDATED;
exports.USER_UPDATE_PREFERENCES_UPDATE_FAILED = USER_UPDATE_PREFERENCES_UPDATE_FAILED;
